import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Paper,
  Chip,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import CakeIcon from '@mui/icons-material/Cake';
import WcIcon from '@mui/icons-material/Wc';
import VerifiedIcon from '@mui/icons-material/Verified';
import BadgeIcon from '@mui/icons-material/Badge';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

// Primary accent shared with /home, /attendance & /payslip (FORTHEYE soft cards).
const ACCENT = '#2f6bff';

const InfoCard = ({ icon, label, value, accent = ACCENT }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 1.5, sm: 1.75 },
      borderRadius: '16px',
      border: '1px solid #eef0f4',
      bgcolor: '#fff',
      height: '100%',
      transition: 'all 0.2s ease',
      '&:hover': {
        borderColor: `${accent}40`,
        boxShadow: `0 6px 18px ${accent}14`,
        transform: 'translateY(-2px)',
      },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{
        width: 42, height: 42, borderRadius: '12px', flexShrink: 0,
        backgroundColor: `${accent}14`, color: accent,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        {React.cloneElement(icon, { sx: { fontSize: 20 } })}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: '#9ca3af', display: 'block', fontSize: '0.66rem',
            lineHeight: 1.2, mb: 0.4, textTransform: 'uppercase',
            letterSpacing: 0.4, fontWeight: 700,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontWeight: 600, color: '#111827', fontSize: '0.9rem', lineHeight: 1.3,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}
        >
          {value || "Not Provided"}
        </Typography>
      </Box>
    </Box>
  </Paper>
);

const Emppersonal = ({ data }) => {
  const personalInfo = [
    { icon: <PersonIcon />, label: "Full Name", value: data?.name },
    { icon: <BadgeIcon />, label: "Employee ID", value: data?.employee_no },
    { icon: <CakeIcon />, label: "Date of Birth", value: data?.date_of_birth },
    { icon: <WcIcon />, label: "Gender", value: data?.gender },
    { icon: <PhoneIcon />, label: "Contact", value: data?.mobile_number },
    { icon: <EmailIcon />, label: "Email", value: data?.email },
    { icon: <LinkedInIcon />, label: "LinkedIn", value: data?.linkedin },
    { icon: <FacebookIcon />, label: "Facebook", value: data?.facebook },
    { icon: <InstagramIcon />, label: "Instagram", value: data?.instagram },
  ];

  return (
    <Box>
      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        {personalInfo.map((info, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <InfoCard {...info} />
          </Grid>
        ))}
      </Grid>

      {/* Status Badge */}
      {data?.status && (
        <Box sx={{ mt: 2.5, display: 'flex', gap: 1 }}>
          <Chip
            icon={<VerifiedIcon sx={{ fontSize: '16px !important', color: '#16a34a !important' }} />}
            label={data.status}
            size="small"
            sx={{
              fontWeight: 600, fontSize: '0.75rem', height: 28,
              textTransform: 'capitalize', bgcolor: '#f0fdf4', color: '#16a34a',
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default Emppersonal;
